import React from 'react';

const Check = props => {
  return (
    <svg
      width="22px"
      height="16px"
      viewBox="0 0 22 16"
      className={props.className}
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <polygon
          id=""
          fill="#3C3C3C"
          points="21.896 1.354 7.784 15.514 0.104 7.786 1.352 6.538 7.784 12.994 20.648 0.106"
        />
      </g>
    </svg>
  );
};

export default Check;
